const oneDay = 1000 * 60 * 60 * 24;

export const initialComplianceForm = {
    id: "",
    name: "",
    categoryId: "",
    requirement: "",
    organization: "",
    userId: "",
    description: "",
    docs: [],
    siteIds: "",
    currentStatus: "",
    expiryDate: "",
};

export const getComplianceStatus = (currentStatus, expiryDate) => {
    if (currentStatus !== "Ongoing" || !expiryDate) return currentStatus;

    const expiryTime = new Date(expiryDate).getTime();
    const currentTime = new Date().getTime();

    // DO NOT CHANGE ORDER !!!
    if (expiryTime < currentTime) return "Expired";
    if (expiryTime < currentTime + oneDay * 28) return "Expiring Soon";
    if (expiryTime >= currentTime + oneDay * 28) return "In Force";

    return "Ongoing";
};

export const getStatusClass = (status) => {
    switch (status) {
        case "In Force":
            return "success";
        case "Expiring Soon":
            return "orange";
        case "Ongoing":
            return "orange";
        case "In Progress":
            return "success";
        case "Expired":
            return "notstarted";
        case "Pending":
            return "notstarted";
        default:
            return "";
    }
}